"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentReplyRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const feedback_1 = require("../../constants/feedback");
class CommentReplyRequestDto {}
exports.CommentReplyRequestDto = CommentReplyRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: feedback_1.FEEDBACK_REPLY_MAX_LENGTH,
  required: false,
  description: 'Required unless at least one attachment is sent.'
}), __metadata("design:type", String)], CommentReplyRequestDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'array',
  items: {
    type: 'string',
    format: 'binary'
  },
  required: false,
  maxItems: feedback_1.FEEDBACK_ATTACHMENT_MAX_COUNT,
  description: "multipart/form-data only. JPEG, PNG or WebP, up to ".concat(feedback_1.FEEDBACK_ATTACHMENT_MAX_BYTES / (1024 * 1024), "MB each.")
}), __metadata("design:type", Array)], CommentReplyRequestDto.prototype, "attachments", void 0);
//# sourceMappingURL=CommentReplyRequest.dto.js.map